const money = (value) => `$${Number(value || 0).toLocaleString()}`;
const percent = (value) => `${Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;

export function RunPreviewGrid({ preview }) {
  const start = preview?.starting ?? {};
  const debt = preview?.debt ?? {};
  const pack = preview?.event_pack ?? {};
  const mode = preview?.game_mode ?? {};
  const starterJunk = preview?.starter_junk ?? {};
  const travelRisk = preview?.travel_risk ?? {};
  const debtPhaseEconomy = preview?.debt_phase_economy ?? {};
  const sellFactors = debtPhaseEconomy.sell_bulk_factors ?? {};
  const nearMiss = debtPhaseEconomy.near_miss_extension ?? {};
  return (
    <div className="reset-preview-grid">
      <div className="reset-preview-wide"><span>Game mode</span><strong>{mode.title || mode.id || 'Classic Run'}</strong><small>{mode.tagline || mode.id || 'classic_30'}</small></div>
      <div className="reset-preview-wide"><span>Event pack</span><strong>{pack.title || pack.id || 'Unknown pack'}</strong><small>{pack.id || 'unknown'} · version {pack.version ?? '?'}</small></div>
      <div><span>Difficulty</span><strong>{String(preview?.difficulty || 'unknown').toUpperCase()}</strong></div>
      <div><span>Maximum days</span><strong>{Number(start.max_days || mode.max_days || 0)}</strong></div>
      <div><span>Debt deadline</span><strong>Day {Number(mode.debt_deadline || start.max_days || 0)}</strong><small>{mode.requires_debt_clearance ? 'Debt must be cleared to continue' : 'Run ends at the day limit'}</small></div>
      <div><span>Starting location</span><strong>{start.location_name || start.location_id || 'Home'}</strong><small>{start.location_id || 'home'}</small></div>
      <div><span>Starting cash</span><strong>{money(start.cash)}</strong></div>
      <div><span>Starting debt</span><strong className="debt-text">{money(start.debt)}</strong></div>
      <div><span>Travel debt growth</span><strong>{percent(debt.travel_growth_percent)} per normal trip</strong><small>Multiplier {Number(debt.travel_multiplier || 1).toFixed(3).replace(/0+$/, '').replace(/\.$/, '')}</small></div>
      <div><span>Loan charge</span><strong>{percent(debt.loan_charge_percent)}</strong><small>Multiplier {Number(debt.loan_multiplier || 1).toFixed(2)}</small></div>
      <div><span>Starting health</span><strong>{Number(start.health || 0)}</strong></div>
      <div><span>Starting reputation</span><strong>{Number(start.street_reputation || 0)}</strong></div>
      <div><span>Carry capacity</span><strong>{Number(start.carry_capacity || 0).toLocaleString()}g</strong></div>
      {starterJunk.enabled && (
        <div className="reset-preview-wide long-haul-preview-bonus">
          <span>Long Haul starter junk</span>
          <strong>{Number(starterJunk.minimum_items || 0)}–{Number(starterJunk.maximum_items || 0)} pawnable items</strong>
          <small>{money(starterJunk.minimum_fence_value)}–{money(starterJunk.maximum_fence_value)} combined fence value; exact items are rolled by the hub when the run is created.</small>
        </div>
      )}
      {debtPhaseEconomy.enabled && (
        <div className="reset-preview-wide long-haul-preview-economy">
          <span>Long Haul debt-phase economy</span>
          <strong>Cash buyers +{percent(debtPhaseEconomy.cash_buyer_premium_percent)} · Gentler bulk selling</strong>
          <small>
            Sale payout factors: under 28g {percent(Number(sellFactors.under_28 || 1) * 100)}, 28g+ {percent(Number(sellFactors.from_28 || 1) * 100)}, 112g+ {percent(Number(sellFactors.from_112 || 1) * 100)}, 448g+ {percent(Number(sellFactors.from_448 || 1) * 100)}. Visited-market prices are recorded in your notebook.
          </small>
          {nearMiss.enabled && (
            <small>
              One near-miss extension is available with {money(nearMiss.maximum_remaining_debt)} or less left at the deadline: +{Number(nearMiss.extra_days || 0)} days with a {percent(nearMiss.penalty_percent)} debt penalty.
            </small>
          )}
        </div>
      )}
      {(Number(travelRisk.police_increase_percent || 0) > 0 || Number(travelRisk.mugging_increase_percent || 0) > 0) && (
        <div className="reset-preview-wide long-haul-preview-danger">
          <span>Long Haul travel heat</span>
          <strong>Police +{percent(travelRisk.police_increase_percent)} · Muggings +{percent(travelRisk.mugging_increase_percent)}</strong>
          <small>Roadside micro-encounter chance at this difficulty: {percent(travelRisk.selected_micro_percent)}. Scene-specific encounter gates remain independently controlled by the hub.</small>
        </div>
      )}
    </div>
  );
}
